import { TaskCriticalityEnum } from 'src/graphql/schema';
import { CRITICALITY_CONFIG, getWorstCriticality } from 'src/shared/mappings/criticality';
import { cn } from 'src/lib/utils';
import { Badge } from '@/components/ui/badge';

import { useAppCard } from '../model';

const CRITICALITY_CLASS_NAME: Record<TaskCriticalityEnum, string> = {
  [TaskCriticalityEnum.High]: 'bg-red-100 text-destructive',
  [TaskCriticalityEnum.Medium]: 'bg-orange-100 text-orange-700',
  [TaskCriticalityEnum.Low]: 'bg-sky-100 text-sky-700',
};

const UnreadTasksBadge = () => {
  const { data } = useAppCard();
  const worstCriticality = getWorstCriticality(data.taskCounts);

  if (!worstCriticality) return null;

  const { icon: Icon } = CRITICALITY_CONFIG[worstCriticality];

  return (
    <Badge
      data-criticality={worstCriticality}
      variant="pill"
      className={cn('ml-auto border-0 shrink-0 px-2.5 py-1 font-semibold', CRITICALITY_CLASS_NAME[worstCriticality])}
    >
      <Icon className="size-3 shrink-0" />
      Unread tasks
    </Badge>
  );
};

export { UnreadTasksBadge };
